{
  "version": 1,
  "asset_id": "340e9eb4-f412-46d7-9bdc-ba1e28cf9308",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/340e9eb4-f412-46d7-9bdc-ba1e28cf9308/mark-96.png",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/340e9eb4-f412-46d7-9bdc-ba1e28cf9308/mark-96.png",
  "original_filename": "mark-96.png",
  "size": 6268,
  "content_type": "image/png",
  "created_at": "2026-07-25T02:18:41Z"
}
